// src/components/layout/Footer.jsx
import { Link } from "react-router-dom";

export default function Footer() {
  const linksRow1 = [
    { label: "Toutes les catégories", href: "/catalog" },
    { label: "Annuaire des boutiques", href: "/stores" },
    { label: "Carrières", href: "/careers" },
    { label: "À propos de GoShop", href: "/corporate" },
    { label: "Devenir vendeur", href: "/become-vendor" },
    { label: "Aide", href: "/help" },
    { label: "Rappels produits", href: "/recalls" },
    { label: "Accessibilité", href: "/accessibility" },
  ];

  const linksRow2 = [
    { label: "Conditions d’utilisation (CGU)", href: "/terms" },
    { label: "Politique de confidentialité", href: "/privacy-policy" },
    { label: "Charte de la communauté", href: "/community" },
    { label: "Service client", href: "/contact" },
    { label: "Télécharger l’application", href: "/app" },
  ];

  return (
    <section className="site-footer mt-5">
      {/* Bandeau feedback clair */}
      <div className="footer-feedback-bar">
        <div className="container text-center py-4">
          <p className="mb-2 footer-feedback-text">
            Votre avis compte ! Aidez-nous à améliorer GoShop.
          </p>

          <button
            type="button"
            className="footer-feedback-btn"
            onClick={() => {
              // tu peux ouvrir un modal ou rediriger vers une page
              window.location.href = "/feedback";
            }}
          >
            Donner mon avis
          </button>
        </div>
      </div>

      {/* Barre principale avec liens */}
      <footer className="footer-main">
        <div className="container py-3">
          {/* Ligne 1 */}
          <div className="footer-links-row">
            {linksRow1.map((l) => (
              <Link key={l.label} to={l.href} className="footer-link">
                {l.label}
              </Link>
            ))}
          </div>

          {/* Ligne 2 */}
          <div className="footer-links-row mt-1">
            {linksRow2.map((l) => (
              <Link key={l.label} to={l.href} className="footer-link">
                {l.label}
              </Link>
            ))}
          </div>

          {/* Copyright */}
          <div className="footer-copy mt-3">
            © {new Date().getFullYear()} GoShop. Les marques, logos et noms de
            produits appartiennent à leurs propriétaires respectifs. Tous droits
            réservés.
          </div>
        </div>
      </footer>
    </section>
  );
}